import { render } from "./OperationPage.vue?vue&type=template&id=08bec04c"
import script from "./OperationPage.vue?vue&type=script&lang=js"
export * from "./OperationPage.vue?vue&type=script&lang=js"

import "./OperationPage.vue?vue&type=style&index=0&id=08bec04c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__